export const environment = {
  production: false,
  apiProjectUrl: "https://a314-projects-dev.sp.avwaveinteractive.com/projects",
  apiUrlAdmin:
    "https://a314-admin-users-dev.sp.avwaveinteractive.com/admin-users",
  apiGoogleStorage:
    "https://a314-google-storage-dev.sp.avwaveinteractive.com/storage",
  urlStorage: "https://storage.googleapis.com/sp-avwave-dev/",
  testUser: {
    // tslint:disable-line
    token: "cualquiercosa",
    email: "user@user.user",
  },
};
